import { useMemo } from "react";
import styled from "styled-components";
import { getWeekNumberText } from "./sidePanelFunctions";
import { DATETIME_FORMAT_NO_SECONDS } from "@shared/common/utils/luxonHelpers";
import { Scenario } from "@opstel/query/api/scenario";

interface ScenarioInfoProps {
  readonly instanceMetadata?: Scenario | null;
}

export function ScenarioInfo({ instanceMetadata }: ScenarioInfoProps): React.JSX.Element {
  const weekNumberText = useMemo(() => {
    return getWeekNumberText(
      instanceMetadata?.scenarioStart.weekNumber,
      instanceMetadata?.scenarioEnd.weekNumber,
    );
  }, [instanceMetadata]);

  return (
    <ScenarioSidePanelInfoContainer>
      <ScenarioTitleContainer>
        <ScenarioTitle>
          {instanceMetadata?.location} {weekNumberText && `(${weekNumberText})`}
        </ScenarioTitle>
        {instanceMetadata?.isSolvedByHip && (
          <tractie-tag color="purple" appearance="subtle" title="Is opgelost door HIP" size="m">
            HIP
          </tractie-tag>
        )}
      </ScenarioTitleContainer>
      <ScenarioIntervalInfo>
        {instanceMetadata?.scenarioStart.toFormat(DATETIME_FORMAT_NO_SECONDS)} t/m{" "}
        {instanceMetadata?.scenarioEnd.toFormat(DATETIME_FORMAT_NO_SECONDS)}
      </ScenarioIntervalInfo>
    </ScenarioSidePanelInfoContainer>
  );
}

const ScenarioSidePanelInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing.spacing1.toString()};
`;

const ScenarioTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const ScenarioIntervalInfo = styled.span`
  color: ${(props) => props.theme.colors.contentSubtle};
  ${(props) => props.theme.typography.text.regular.sm};
`;

const ScenarioTitle = styled.h1`
  font-size: var(--tractie-typography-size-xl);
  font-weight: var(--tractie-typography-weight-medium);
  margin: 0;
`;
